<template>
    <el-dialog :title="title"
               :visible="showDialog"
               @close="close"
               @open="create"
               width="480px">
        <form autocomplete="off" @submit.prevent="submit" v-loading="loading">
            <div class="form-body">
                <div class="row">
                    <div class="col-md-12">
                        <x-input  v-model="form.id"
                                  label="Código"
                                  :readonly="form.is_locked"></x-input>
                    </div>
                    <div class="col-md-12">
                        <x-input  v-model="form.name"
                                  label="Nombre"
                                  :readonly="form.is_locked"></x-input>
                    </div>
                    <div class="col-md-12 mt-2">
                        <x-checkbox v-model="form.is_exportation"
                                    :disabled="form.is_locked"
                                    label="¿Exportación?"></x-checkbox>
                    </div>
                    <div class="col-md-12 mt-2">
                        <x-checkbox v-model="form.is_active" label="¿Activo?"></x-checkbox>
                    </div>
                </div>
            </div>
            <div class="form-actions text-right mt-4">
                <el-button @click.prevent="close()">Cancelar</el-button>
                <el-button type="primary" native-type="submit" :loading="loadingSubmit">Guardar</el-button>
            </div>
        </form>
    </el-dialog>
</template>

<script>

import XInput from "../../../../components/Form/XInput.vue";
import XCheckbox from "../../../../components/Form/XCheckbox.vue";

export default {
    name: 'OperationTypeForm',
    components: {XCheckbox, XInput},
    props: ['showDialog', 'recordId'],
    data() {
        return {
            loading: false,
            loadingSubmit: false,
            title: '',
            resource: 'maintenances/operation_types',
            errors: {},
            form: {},
        }
    },
    created() {
        this.initForm()
    },
    methods: {
        initForm() {
            this.errors = {}
            this.form = {
                id: null,
                name: null,
                is_exportation: false,
                is_active: true
            }
        },
        async create() {
            this.loading = true
            this.title = (this.recordId) ? 'Editar tipo de operación' : 'Nuevo tipo de operación'
            if (this.recordId) {
                await this.$http.get(`/${this.resource}/record/${this.recordId}`)
                    .then(response => {
                        this.form = Object.assign({}, this.form, response.data.data)
                    })
            }
            this.loading = false
        },
        submit() {
            this.loading = true
            this.loadingSubmit = true
            this.$http.post(`/${this.resource}`, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                        this.$eventHub.$emit('reloadData')
                        this.close()
                    } else {
                        this.$message.error(response.data.message)
                    }
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data
                    } else {
                        console.log(error)
                    }
                })
                .finally(() => {
                    this.loadingSubmit = false
                    this.loading = false
                })
        },
        close() {
            this.$emit('update:showDialog', false)
            this.initForm()
        },
    }
}
</script>
